import * as React from "react";
import SEO from "@src/components/SEO";
import { useAppcheck } from "@src/utils/appcheck";

type AppcheckProps = {
  children: React.ReactNode;
};

const AppcheckBase: React.FC<AppcheckProps> = ({ children }) => {
  useAppcheck();
  return (
    <>
      <SEO noindex={true} />
      {children}
    </>
  );
};

export default AppcheckBase;
